import React from 'react';
import { COLUMN_GROUPS } from '../../utils/colors';

export default function ColumnToggle({ visibleGroups, setVisibleGroups }) {
  const toggle = (group) => {
    setVisibleGroups(prev => ({ ...prev, [group]: !prev[group] }));
  };

  return (
    <div className="column-toggle">
      <label>Column Groups</label>
      <div className="toggle-chips">
        {Object.keys(COLUMN_GROUPS).map(group => (
          <button
            key={group}
            className={`toggle-chip ${visibleGroups[group] ? 'active' : ''}`}
            onClick={() => toggle(group)}
          >
            {group}
          </button>
        ))}
      </div>
    </div>
  );
}
